<template>
  <section class="model_engine_box_height">
    <div id="webglContainer"  class="model_engine_box_height">
      <!--左边构建树列表-->
      <div class="model_actor_tree">
        <ActorTree :data="data" :model-id="tokenId" @actorCheck="actorCheck" :hide-label="false"></ActorTree>
      </div>
      <!--工具栏-->
      <div class="engine_toolbar">
       <ModelToolBar :mode="mode" :tokenId="tokenId" ref="toolbar"></ModelToolBar>
      </div>
    </div>
  </section>
</template>

<script>
  import ModelToolBar from "./ModelToolBar";
  import ActorTree from "./ActorTree";

  export default {
    name: "Engine",
    components: {ActorTree, ModelToolBar},
    props: {
      data: {}
    },
    data(){
      return {
        mode:'vertical',//horizontal
        //mode:'horizontal',
        tokenId:null,
        file:null,
      }
    },
    methods:{
      actorCheck:function(){
        this.$refs.toolbar.doManageMode(2);
      }
    },
    created(){
      this.tokenId = this.GLOBAL.getURLParam('modelId');
      this.file = this.GLOBAL.getURLParam('file');
    },
    mounted() {
      // let index = this.modelUrl.lastIndexOf('/');
      // let file = this.modelUrl.substring(index+1,this.modelUrl.length-4);
      EngineInit("webglContainer");	// 加载模型
      AddModel("http://121.40.229.90:83/"+this.file+"/"+this.file+"List.json",this.tokenId, true);
      SetClickMode(0);
      SetKeyBoardEnable(false);
    },
    destroyed() {
      // ClearScene();
      hasSelectionIds = [];
      searchProperty=false;
    }
  }
</script>

<style scoped>
  .model_engine_box_height{height: 750px;}
  #webglContainer {
    position: relative;
    border-bottom: 2px solid #c9c9c9;
  }
  .model_actor_tree{ width: 240px; position: absolute; top: 0px; left: 0px; background: #fff;height: 100%; border: 1px solid #c9c9c9}

  /*工具栏*/
  .engine_toolbar{ position: absolute;top: 20px; right: 20px;}
  .property_list{width:100%;height: 30px; line-height: 30px;margin: auto;position: relative;}
  .el-tabs--border-card>.el-tabs__content {
    padding: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/model/Engine.vue